import React from 'react';
import { IMAGE_VERSION } from '../version.js';

function Image({
  src,
  alt = "Image Name",
  className = "",
  ...props
}) {

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={(e) => {
        e.target.src = "/assets/images/no_image.png?ver=${IMAGE_VERSION}`}"
      }}
      {...props}
    />
  );
}

export default Image;
